<template>
  <v-app>
    <transition
      appear
      name="appear"
    >
      <v-content style="width: 100%;">
        <v-container
          fluid
          class="content show"
        >
          <transition
            name="slide-fade"
            mode="out-in"
          >
            <router-view
              v-if="matched"
              style="min-height: 426px; margin-bottom: 250px;"
            />
          </transition>

          <router-link to="/">
            <img
              v-show="showLogo"
              src="@/assets/logo.png"
              alt="Impressia fotó • web • marketing"
              :class="{ logo: !matched, smallLogo: matched }"
            >
          </router-link>

          <div class="navigation">
            <router-link
              :to="{ name: 'Development' }"
              active-class="active-navigation"
            >
              <v-tooltip left>
                <img
                  slot="activator"
                  class="ma-1"
                  src="@/assets/development.png"
                  alt="Szoftverfejlesztés"
                >

                <span>Szoftverfejlesztés</span>
              </v-tooltip>
            </router-link>

            <router-link
              :to="{ name: 'Marketing' }"
              active-class="active-navigation"
            >
              <v-tooltip top>
                <img
                  slot="activator"
                  class="ma-1"
                  src="@/assets/marketing.png"
                  alt="Marketing"
                >

                <span>Marketing</span>
              </v-tooltip>
            </router-link>

            <router-link
              :to="{ name: 'References' }"
              active-class="active-navigation"
            >
              <v-tooltip bottom>
                <img
                  slot="activator"
                  class="ma-1"
                  src="@/assets/references.png"
                  alt="100% elégedettség."
                >

                <span>100% elégedettség.</span>
              </v-tooltip>
            </router-link>


            <router-link
              :to="{ name: 'Contact' }"
              active-class="active-navigation"
            >
              <v-tooltip right>
                <img
                  slot="activator"
                  class="ma-1"
                  src="@/assets/contact.png"
                  alt="Kapcsolat"
                >

                <span>Kapcsolat</span>
              </v-tooltip>
            </router-link>
          </div>

          <footer>
            <router-link :to="{ name: 'PrivacyStatement' }">
              Adatvédelmi nyilatkozat
            </router-link>
            |
            <router-link :to="{ name: 'LegalNotice' }">
              Jogi nyilatkozat
            </router-link>
          </footer>
        </v-container>

        <the-cookie-bar />
      </v-content>
    </transition>
  </v-app>
</template>

<script>
import TheCookieBar from '@/components/TheCookieBar.vue';

export default {
  name: 'App',
  components: {
    TheCookieBar,
  },
  metaInfo() {
    if (!this.matched) {
      return {
        title: 'Impressia',
        meta: [
          {
            name: 'description',
            content: 'Impressia fotó • web • marketing',
          },
        ],
      };
    }

    return {};
  },
  data() {
    return {
      showLogo: false,
    };
  },
  computed: {
    matched() {
      return !!this.$route.matched.length;
    },
  },
  created() {
    this.$router.onReady(() => {
      this.showLogo = true;
    });
  },
};
</script>

<style scoped>
.theme--light.application {
  background-color: white;
}

@media (max-width: 1024px) {
  .v-tooltip__content {
    display: none;
  }
}

.content {
  max-width: 1170px;
  height: 100%;
  overflow: hidden;
}

.logo {
  position: absolute;
  width: 90vw;
  min-width: 256px;
  max-width: 600px;
  transition: bottom 0.8s ease-in-out, max-width 0.8s ease-in-out, transform 0.8s ease-in-out;
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
  cursor: default;
}

@media (max-height: 650px) {
  .logo {
    bottom: 65%;
    max-width: 454px;
  }
}

.smallLogo {
  position: absolute;
  width: 90vw;
  max-width: 288px;
  transition: bottom 0.8s ease-in-out, max-width 0.8s ease-in-out, transform 0.8s ease-in-out;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%);
  z-index: 2;
}

.navigation {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  text-align: center;
  width: 100vw;
  height: 220px;
  max-height: 40%;
}

.navigation img {
  width: 20%;
  max-width: 60px;
  transition: transform 0.2s ease-in-out;
}

.active-navigation img {
  transform: scale(1.12);
}

.navigation img:hover {
  transform: scale(1.12);
}

.slide-fade-enter-active {
  transition: transform 0.4s ease, opacity 0.4s ease;
  transition-delay: 0.5s;
}

.slide-fade-leave-active {
  transition: transform 0.4s cubic-bezier(1, 0.5, 0.8, 1), opacity 0.4s ease;
}

.slide-fade-enter {
  transform: translateY(200px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-100px);
  opacity: 0;
}

.appear-enter-active,
.appear-leave-active {
  transition: opacity 1s;
}
.appear-enter,
.appear-leave-to {
  opacity: 0;
}

footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}

footer a {
  color: black;
  font-family: 'Raleway', sans-serif;
  text-decoration: none;
}
</style>
